import Modal from '@src/common/Modal';
import React,{ useEffect, useState } from 'react';
import FullPageLoader from '@common/FullPageLoader';
import { useLanguage } from '@src/context/LanguageContext';


interface BankDetailModalProps {
    show: boolean;
    handleClose: () => void;
    data?:any,
}

const BankDetailModal = ({show,handleClose,data}: BankDetailModalProps) => {

    const [loading, setLoading] = useState(false);
    const {translations} = useLanguage();
     
  

    const DetailRow = ({ label, value }: { label: string; value: string }) => (
        <div className="detail-row">
            <span className="detail-label">{label}</span>
            <span className="detail-value">{value}</span>
        </div>
    );

    useEffect(() => {
        if (show) document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])
    return(
        <React.Fragment>
            <FullPageLoader show={loading} /> 
            <div className= {`model-outer`}>
            <Modal show={show} handleClose={handleClose}>
                <div className="modal-header">
            <h2>Bank Details</h2>
          </div>
                <div className="modal-body">
                 {
                    <div className="details col-md-12">
                        <DetailRow label={translations?.PROFILE?.BANK_NAME} value={data?.bank_name} />
                        <DetailRow label={translations?.PROFILE?.ACCOUNT_NUMBER} value={data?.account_no} />
                        <DetailRow label={translations?.PROFILE?.BENEFICIARY_NAME} value={data?.beneficiary_name} />
                        <DetailRow label={translations?.PROFILE?.BRANCH_NAME} value={data?.branch_name} />
                    </div>
                 }
                </div>
            </Modal>
            </div>
        </React.Fragment>
    );
}

export default BankDetailModal;    